import { render, staticRenderFns } from "./MainPanelV2026.vue?vue&type=template&id=507e273c&scoped=true"
import script from "./MainPanelV2026.vue?vue&type=script&lang=js"
export * from "./MainPanelV2026.vue?vue&type=script&lang=js"
import style0 from "./MainPanelV2026.vue?vue&type=style&index=0&id=507e273c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507e273c",
  null
  
)

export default component.exports